import React, { useEffect, useState } from 'react';
import './App.css';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import AddStakeholderModal from './CreateStakeholder';

const StakeholdersModal = ({ visible, onClose, workspaceId,onStakeholderCountUpdate, workspaceName }) => {
  const [stakeholders, setStakeholders] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedStakeholder, setSelectedStakeholder] = useState(null); // State for editing a stakeholder
  const [token, setToken] = useState(null);

  useEffect(() => {
    const savedToken = sessionStorage.getItem('token');
    if (savedToken) {
      setToken(savedToken);
    }
    if (visible && workspaceId) {
      const fetchStakeholders = async () => {
        try {
          const response = await fetch(`https://stage-apiplatform.finkraft.ai/api/meta/stakeholder/${workspaceId}`);
          const data = await response.json();
          setStakeholders(data.data && Array.isArray(data.data) ? data.data : []);
        } catch (error) {
          console.error("Error fetching stakeholders:", error);
          setStakeholders([]);
        }
      };
      fetchStakeholders();
    }
  }, [visible, workspaceId]);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this stakeholder?");
    if (!confirmDelete) return;

    try {
      const response = await fetch(`https://stage-apiplatform.finkraft.ai/api/meta/stakeholder/delete/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // Optional: include if your API requires it
      }
      });

      if (response.ok) {
        setStakeholders(stakeholders.filter(stakeholder => stakeholder.id !== id)); // Remove stakeholder from state
        alert("Stakeholder deleted successfully.");
      } else {
        alert("Failed to delete stakeholder.");
      }
    } catch (error) {
      console.error("Error deleting stakeholder:", error);
      alert("Error deleting stakeholder.");
    }
  };

  const handleEdit = (stakeholder) => {
    console.log('Editing stakeholder:', stakeholder);
    setSelectedStakeholder(stakeholder);
    setIsAddModalOpen(true);
  };

  const columnDefs = [
    { headerName: "ID", field: "id" },
    { headerName: "Name", field: "name" },
    { headerName: "Designation", field: "designation" },
    { headerName: "Email", field: "email" },
    { headerName: "Phone Number", field: "number" },
    { headerName: "Department", field: "department" },
    { headerName: "Created At", field: "created_at" },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <div>
          <button
            className="edit-button"
            onClick={() => handleEdit(params.data)}
          >
            Edit
          </button>
          <button
            className="delete-button"
            onClick={() => handleDelete(params.data.id)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  if (!visible) {
    return null; // Don't render the modal if it's not visible
  }

  // Trigger onStakeholderCountUpdate when the modal is closed
  const handleClose = () => {
    onStakeholderCountUpdate(stakeholders.length); // Send stakeholder count to parent
    onClose(); // Then close the modal
  };

  const handleStakeholderUpdate = (newStakeholder) => {
    if (selectedStakeholder) {
      // Update existing stakeholder
      setStakeholders(stakeholders.map(s => (s.id === newStakeholder.id ? newStakeholder : s)));
    } else {
      // Add new stakeholder
      setStakeholders([...stakeholders, newStakeholder]);
    }

    setIsAddModalOpen(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content-stakeholder">
        <div className="stakeholder-modal-header ">
          <h2>Stakeholders for Workspace : {workspaceName}</h2>
          <button className="modal-close" onClick={handleClose}>&times;</button>
        </div>
        <div className="modal-body-stakeholder">
          <div>
            <button className="add-stakeholder-btn" onClick={() => {
              setSelectedStakeholder(null); // Reset for adding a new stakeholder
              setIsAddModalOpen(true);
            }}>
              Add Stakeholder
            </button>
          </div>
          <div className="ag-theme-alpine" style={{ height: '500px', width: '100%' }}>
            <AgGridReact
              rowData={stakeholders}
              columnDefs={columnDefs}
              domLayout="autoHeight"
            />
          </div>
        </div>
      </div>

      {/* Add Stakeholder Modal */}
      {isAddModalOpen && (
        <AddStakeholderModal
        visible={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        workspaceId={workspaceId}
        workspaceName={workspaceName}
        initialStakeholder={selectedStakeholder}
        onStakeholderAdded={handleStakeholderUpdate}
      />
      
      )}
    </div>
  );
};

export default StakeholdersModal;
